import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';
import superAdminNavigation from './navigations/superAdminNavigation';
import transformerNavigation from './navigations/transformerNavigation';
import managerNavigation from './navigations/managerNavigation';
import verifierNavigation from './navigations/verifierNavigation';
import collectiveplanNavigation from './navigations/collectiveplanNavigation';
import producerNavigation from './navigations/producerNavigation';
import marketerNavigation from './navigations/marketerNavigation';
import integrativeNavigation from './navigations/integrativeNavigation';
import manufacturerNavigation from './navigations/manufacturerNavigation';
import parseNavigation from './navigations/parseNavigation';


i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);



const navigationConfig = {
	manager:
		managerNavigation,
	collectiveplan:
		collectiveplanNavigation,
	producer:
		producerNavigation,
	transformer:
		transformerNavigation,
	superadmin:
		superAdminNavigation,
	verifier:
		verifierNavigation,
	marketer:
		marketerNavigation,
	integrative:
		integrativeNavigation,
	manufacturer:
		manufacturerNavigation,
	default: parseNavigation(`
group home | Inicio | home | /home
group solutions | Soluciones | lightbulb | /soluciones
group howItWorks | Cómo funciona | settings | /como-funciona
group useCases | Casos de uso | cases | /casos-de-uso
group education | Educación | school | /educacion
group verificationsCertificates | Validar certificado | card_membership | /verifications-certificates
group ContactUs | Contacto | connect_without_contact | /contact
group auth | Ingresar | verified_user
	item login | Iniciar sesion | lock | /auth/login
	item register | Registrarse | person_add | /auth/register
`)
};


export default navigationConfig;
